import GenericSideEffect from './generic-sideeffect';

export default GenericSideEffect;
